import { render, staticRenderFns } from "./SidebarEditPersonalProfile.vue?vue&type=template&id=0ddd2e2c&scoped=true&"
import script from "./SidebarEditPersonalProfile.vue?vue&type=script&lang=js&"
export * from "./SidebarEditPersonalProfile.vue?vue&type=script&lang=js&"
import style0 from "./SidebarEditPersonalProfile.vue?vue&type=style&index=0&id=0ddd2e2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ddd2e2c",
  null
  
)

export default component.exports